import React from 'react'
import Footer from '../components/Footer'

const project01 = () => {
  return (
    <div>
      <div className="projectsContainer">
        Page under construction.
      </div>
      <Footer />
    </div>
  )
}

export default project01